import React from "react";
import { Card } from "react-bootstrap";
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";
import withRouter from "../../util/WithRouter";

const containerStyle = {
  width: "100%",
  height: "65vh",
};

// Classic Google Maps Pin SVG Path
const locationPinPath =
  "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z";

// Generate a consistent color based on the user's name string
const stringToHslColor = (str) => {
  if (!str) return "#1d4ed8";
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = Math.abs(hash % 360);
  return `hsl(${h}, 70%, 50%)`;
};

class LocationMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isScriptLoaded: false };
  }

  handleScriptLoad = () => {
    this.setState({ isScriptLoaded: true });
  };

  render() {
    const { data } = this.props;
    const { isScriptLoaded } = this.state;
    
    // Determine color based on the first salesperson in the list
    const userColor = data.length > 0 ? stringToHslColor(data[0].salesPerson) : "#1d4ed8";
    
    const defaultCenter = data.length > 0 
      ? { lat: data[0].lat, lng: data[0].lng } 
      : { lat: 19.0760, lng: 72.8777 }; // Default to Mumbai

    return (
      <Card className="h-100 shadow-sm border-0">
        <Card.Body className="p-0 position-relative">
          <LoadScript 
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY || "AIzaSyBIqXz1A8OhSJuDvAhRNpbjIwfVyNvfFsU"}
            onLoad={this.handleScriptLoad}
          >
            <GoogleMap 
              mapContainerStyle={containerStyle} 
              center={defaultCenter} 
              zoom={14}
              options={{
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                gestureHandling: "greedy" // Better mobile UX
              }}
            >
              {isScriptLoaded && data.map((location) => (
                <Marker
                  key={location.id}
                  position={{ lat: location.lat, lng: location.lng }}
                  icon={{
                    path: locationPinPath,
                    fillColor: userColor,
                    fillOpacity: 1,
                    strokeColor: "#fff",
                    strokeWeight: 2,
                    scale: 1.5,
                    anchor: window.google ? new window.google.maps.Point(12, 24) : undefined,
                  }}
                  title={`${location.salesPerson}\n${location.time}\n${location.address}`}
                />
              ))}
            </GoogleMap>
          </LoadScript>
          
          {!isScriptLoaded && (
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-light bg-opacity-75" style={{ zIndex: 10 }}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading map...</span>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default withRouter(LocationMap);